import {
  buildBaseUrl,
  EntityFrameworkConfig,
  EventDispatcherContext,
  initI18n,
  ModuleMessaging
} from "clavis-nxt-components-custdevtm";
import axios from "axios";
import { render } from "react-dom";
import { Provider } from "react-redux";
import store, { history } from "../../store";
import { ConnectedRouter } from "connected-react-router";
import App from "../../containers/app/App";
import React from "react";

/** @typedef {Object} AxiosBaseObject
 *  @property {string} method
 *  @property {string} url
 * */

/** Generate axios request object.
 *  @return {AxiosBaseObject} */
const generateAxiosRequest = () => {
  return {
    method: "get",
    url: buildBaseUrl() + "/entity/environmentConfig"
  };
};

export const indexLoader = (eventDispatcher, target) => {
  axios(generateAxiosRequest())
    .then(response => {
      console.log(response);
      localStorage.setItem("environment", JSON.stringify(response.data));
      console.log(localStorage.getItem("environment"));

      let modulesConfigObj = null;

      if (response.data.modulesConfigJSON) {
        localStorage.setItem("moduleConfig", response.data.modulesConfigJSON);
        modulesConfigObj = JSON.parse(response.data.modulesConfigJSON);
        console.log(localStorage.getItem("moduleConfig"));
      }

      ModuleMessaging.dispatchEvent("web-platform", "ws-subscribe-to-topic", {
        topic: "/topic/PLS/SYSTEM_MESSAGE_UPDATE",
        module: "platform-services"
      });
      ModuleMessaging.dispatchEvent("web-platform", "ws-subscribe-to-topic", {
        topic: "/topic/PLS/SYSTEM_MESSAGE_DELETE",
        module: "platform-services"
      });

      initI18n().then(() => {
        render(
          <Provider store={store}>
            <ConnectedRouter history={history}>
              <EventDispatcherContext.Provider value={eventDispatcher}>
                <div>
                  <App moduleConfig={modulesConfigObj} />
                </div>
              </EventDispatcherContext.Provider>
            </ConnectedRouter>
          </Provider>,
          target
        );
      });
    })
    .catch(() => {
      if (!generateAxiosRequest().url.includes("platform-services")) {
        EntityFrameworkConfig.contextPath = "platform-services";
        indexLoader(eventDispatcher, target);
      }
    });
};
